// extracted by mini-css-extract-plugin
export default {"sectionTitle":"H95ZyV","siteGateHeaderTitle":"RXw69W"};